var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25,20.5h-3.5c-0.41,0-0.75-0.34-0.75-0.75S16.34,19,16.75,19h3.5c0.69,0,1.25-0.56,1.25-1.25v-0.5 c0-2.34-1.91-4.25-4.25-4.25c-0.69,0-1.37,0.08-2.04,0.24c-0.4,0.09-0.81-0.15-0.9-0.56c-0.09-0.4,0.16-0.81,0.56-0.9 c0.78-0.18,1.58-0.28,2.38-0.28c3.17,0,5.75,2.58,5.75,5.75v0.5C23,19.27,21.77,20.5,20.25,20.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17,10.5c-1.93,0-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5c1.93,0,3.5,1.57,3.5,3.5S18.93,10.5,17,10.5z M17,5c-1.1,0-2,0.9-2,2 s0.9,2,2,2c1.1,0,2-0.9,2-2S18.1,5,17,5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25,22.5h-8c-1.52,0-2.75-1.23-2.75-2.75v-1.5c0-3.72,3.03-6.75,6.75-6.75S15,14.53,15,18.25v1.5 C15,21.27,13.77,22.5,12.25,22.5z M8.25,13C5.35,13,3,15.36,3,18.25v1.5C3,20.44,3.56,21,4.25,21h8c0.69,0,1.25-0.56,1.25-1.25v-1.5 C13.5,15.36,11.15,13,8.25,13z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8,10.5c-2.48,0-4.5-2.02-4.5-4.5S5.52,1.5,8,1.5s4.5,2.02,4.5,4.5S10.48,10.5,8,10.5z M8,3C6.35,3,5,4.35,5,6s1.35,3,3,3 s3-1.35,3-3S9.65,3,8,3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.8f8a28cbdd966a61603bda1607cdabb8.svg";
export { ForwardRef as ReactComponent };